import * as React from 'react'
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Brush } from 'recharts'

let data = [
  {
    ct: '11',
    last: 424,
    this: 1911,
  },
  {
    ct: '12',
    last: 4524,
    this: 18911,
  },
]

function AreaGraph(param) {
  let result = new Array(31).fill({
    ct: +1,
  })
  let result2 = []
  let result3 = []
  result.map((item, index) => {
    const temp1 = {
      ct: `${index + 1}일`,
      last: 0,
      this: 0,
    }
    result2.push(temp1)
  })

  // console.log('result 1:', result)
  // console.log('result 2:', result2)
  if (param !== undefined) {
    // console.log('AreaGraph param:', param)
    if (param.param !== undefined && param.param) {
      param.param.month_total_warning_list.map((item) => {
        const temp = item.day.split('-')
        // console.log('test temp1:', temp[temp.length-1])
        // console.log('test temp2:', result2[temp[temp.length-1]-1])
        result2[temp[temp.length - 1] - 1].this = item.total_count
      })
      param.param.last_month_total_warning_list.map((item) => {
        const temp = item.day.split('-')
        // console.log('test temp3:', temp[temp.length-1])
        // console.log('test temp4:', result2[temp[temp.length-1]-1])
        result2[temp[temp.length - 1] - 1].last = item.total_count
      })
    }
  }
  result2.map((item) => {
    if (item.last > 0 || item.this > 0) {
      const tempObject = { ct: item.ct + '일', last: item.last, this: item.this }
      result3.push(tempObject)
    }
  })
  // console.log('AreaGraph test result3:', result3)
  return (
    <ResponsiveContainer id="bar-chart-container" width="100%" height={100}>
      <AreaChart data={result2} margin={{ top: 10, right: 30, left: 1, bottom: 1 }}>
        <defs>
          <linearGradient id="colorhttp" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#A9DFD8" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#A9DFD8" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="colormqtt" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#F2C8ED" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#F2C8ED" stopOpacity={0} />
          </linearGradient>
          {/* <linearGradient id="colorcoap" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#0000ff" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#0000ff" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="colorws" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#ff0000" stopOpacity={0.8} />
              <stop offset="95%" stopColor="#ff0000" stopOpacity={0} />
            </linearGradient> */}
        </defs>
        <XAxis dataKey="ct" />
        <YAxis />
        <Tooltip />
        <Area type="monotone" dataKey="last" stroke="#A9DFD8" fillOpacity={1} fill="url(#colorhttp)" />
        <Area type="monotone" dataKey="this" stroke="#F2C8ED" fillOpacity={1} fill="url(#colormqtt)" />
        {/* <Area type="monotone" dataKey="coap" stroke="#0000ff" fillOpacity={1} fill="url(#colorcoap)" />
          <Area type="monotone" dataKey="ws" stroke="#ff0000" fillOpacity={1} fill="url(#colorws)" /> */}
      </AreaChart>
    </ResponsiveContainer>
  )
}

export default AreaGraph
